export default __webpack_public_path__ + "static/media/saveIcon.bebc384b.svg";